<!-- Компактный чип доменной записи: показывает название и ведёт на маршрут записи, если он доступен -->
<template>
  <router-link
    v-if="resourceRoute && clickable"
    :to="resourceRoute"
    class="resource-link-chip"
    @click.stop
  >
    {{ display }}
  </router-link>

  <span
    v-else-if="display"
    class="resource-link-chip resource-link-chip--plain"
    :class="{ 'resource-link-chip--muted': muted }"
  >
    {{ display }}
  </span>
</template>

<script>
import { getModelRoute } from "@/utils/routeUtils";

export default {
  name: "BaseResourceLinkChip",

  props: {
    targetResource: {
      type: String,
      default: null,
    },
    resourceId: {
      type: [Number, String],
      default: null,
    },
    routeParams: {
      type: Object,
      default: () => ({}),
    },
    display: {
      type: String,
      default: "",
    },
    clickable: {
      type: Boolean,
      default: true,
    },
    muted: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    resourceRoute() {
      if (!this.targetResource || !this.resourceId) return null;

      return getModelRoute(
        this.targetResource,
        this.resourceId,
        this.routeParams
      );
    },
  },
};
</script>

<style scoped>
.resource-link-chip {
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: 100%;
  min-height: 20px;
  padding: 0 7px;
  border-radius: 999px;
  overflow: hidden;
  background: #e7f7f4;
  color: #056b5c;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-decoration: none;
  text-overflow: ellipsis;
  transition: background 0.2s ease;
  white-space: nowrap;
}

.resource-link-chip:hover {
  background: #c6efea;
}

.resource-link-chip--plain {
  pointer-events: none;
}

.resource-link-chip--muted {
  background: #f3f4f6;
  color: #6b7280;
}
</style>
